import { Switch } from '@headlessui/react';
import React, { useState, useEffect, useContext, useRef } from 'react';
import { format } from 'date-fns';
import { CheckoutContext } from './CheckoutContext';
import { numberFormat, showToast } from '../../Utils';
import { ExclamationCircleIcon } from '@heroicons/react/24/solid';

function CheckoutConfirm(props) {
  const { data, updateData } = useContext(CheckoutContext);
  const [fullPayment, setFullPayment] = useState(!data.payment.isDP);
  const [DP, setDP] = useState(0);

  const name = useRef();
  const phone = useRef();
  const email = useRef();

  useEffect(() => {
    data.payment.isDP = !fullPayment;
    updateData(data);
    if (fullPayment) {
      setDP(0);
    }
  }, [fullPayment])

  useEffect(() => {
    data.payment.DP = DP;
    updateData(data);
    setFullPayment(DP === 0);
  }, [DP])

  let selected_date = new Date(data.selected_date);
  let subtotal = 0;
  let totalSchedule = 0;
  let totalAddon = 0;
  let discount = 0;
  let service_fee = data.service_fee;
  let total = 0;

  data.selected_schedule.map((schedule) => {
    let promo_period = new Date(schedule.promo_period_end);
    console.log("Discount");
    console.log(selected_date);
    console.log(promo_period);
    totalSchedule += schedule.price;
    if (selected_date <= promo_period) {
      discount += schedule.price - schedule.promo_price;
    }
  });
  data.addons.map((addon) => {
    if (addon.unit === "Hour") {
      totalAddon += (addon.price * addon.qty * data.selected_schedule.length);
    } else {
      totalAddon += (addon.price * addon.qty);
    }
  });

  subtotal = totalSchedule + totalAddon;
  total = subtotal - discount + service_fee;

  const toggleFullPayment = (value) => {
    setFullPayment(data.venue.isDP && data.schedules.isDP ? value : true);
  }

  const validate = () => {
    if (
      (data.contact.name === undefined || data.contact.name === "") ||
      (data.contact.phone === undefined || data.contact.phone === "") ||
      (data.contact.email === undefined || data.contact.email === ""))
      return { valid: false, msg: "Silahkan lengkapi data pemesan" }

    if (data.payment.isDP && (data.payment.DP === 0))
      return { valid: false, msg: "Silahkan pilih total DP" }

    return { valid: true, msg: "OK" };
  }

  const onNext = () => {
    data.contact.name = name.current.value;
    data.contact.phone = phone.current.value;
    data.contact.email = email.current.value;
    data.subtotal = subtotal;
    data.totalSchedule = totalSchedule;
    data.totalAddon = totalAddon;
    data.discount = discount;
    data.total = total;
    data.paymentMethod = null;

    updateData(data);

    let { valid, msg } = validate();

    if (valid) {
      props.onNextPageConfirmed();
    } else {
      showToast("Error", "Alert", msg);
    }
  }

  return (
    <div className='md:flex md:gap-x-8 pt-12'>

      <div className='md:w-1/2 mb-8 md:mb-0'>
        <p className='text-md font-semibold mb-4'>Konfirmasi Pesanan</p>
        <div className='px-6 py-6 flex flex-col gap-y-8 border border-gray-300 rounded-xl mb-4 md:mb-0'>

          <div className="flex gap-x-4 flex-grow">
            <div className='gap-y-3 flex flex-col'>
              <p className='text-sm font-bold'>Nama Venue</p>
              <p className='text-sm font-semibold text-gray-800'>{data.venue.name}</p>
            </div>
            <div className="flex-grow" />
            <div className='gap-y-3 flex flex-col mt-0'>
              <p className='text-sm font-bold'>Tanggal Booking</p>
              <p className='text-sm font-semibold text-gray-800'>
                {format(data.selected_date, 'dd MMMM yyyy')}
              </p>
            </div>

          </div>
          <div className="flex gap-x-4 flex-grow">
            <div className='w-1/2 flex flex-col justify-start'>
              <p className="text-sm font-bold text-gray-800">TOTAL BAYAR</p>
              <p className="text-xs text-gray-800">Belum termasuk biaya admin</p>
            </div>
            <div className='w-1/2 flex justify-end'>
              <p className="text-lg font-bold text-gray-800">Rp</p>
              <p className="text-lg font-bold text-gray-800">{numberFormat(total, false)}</p>
            </div>
          </div>
          <hr />

          <div className='gap-y-3 flex flex-col flex-grow'>
            <p className='text-sm font-bold'>Jam Booking</p>
            {
              data.selected_schedule.map((item, index) => (

                <div key={index} className="flex gap-x-4 flex-grow">
                  <div className='w-1/2 flex justify-start'>
                    <p className="text-sm font-bold text-gray-800">{item.hour}</p>
                  </div>
                  <div className='w-1/2 flex justify-end flex-col'>
                    {
                      <div className='flex justify-end'>
                        <p className="text-sm font-bold text-gray-800">Rp</p>
                        <p className="text-sm font-semibold text-gray-800">{numberFormat(item.price, false)}</p>
                      </div>
                    }

                  </div>
                </div>
              ))
            }
          </div>

          {data.addons.length > 0 && (<>
            <div className='gap-y-3 flex flex-col flex-grow'>
              <p className='text-sm font-bold'>Tambahan Add On</p>
              {
                data.addons.map((item, index) => (
                  <div key={index} className="flex gap-x-4 flex-grow">
                    <div className='w-1/2 flex justify-start'>
                      <p className="text-sm font-bold text-gray-800">{item.name} {item.qty} {item.unit !== "Hour" ? item.unit : `x ${data.selected_schedule.length} ${item.unit} `}</p>
                    </div>
                    <div className='w-1/2 flex justify-end'>
                      <p className="text-sm font-bold text-gray-800">Rp</p>
                      {/* <div className="flex-grow" /> */}
                      <p className="text-sm font-bold text-gray-800">{numberFormat(item.unit !== "Hour" ? item.qty * item.price : item.qty * item.price * data.selected_schedule.length, false)}</p>
                    </div>
                  </div>
                ))
              }
            </div>
          </>)}
          <hr />
          <div className='gap-y-3 flex flex-col flex-grow mt-[-14px]'>

            <div className="flex gap-x-4 flex-grow">
              <div className='w-1/2 flex justify-end'>
                <p className="text-sm font-bold text-gray-800">VOUCHER & DISKON</p>
              </div>
              <div className='w-1/2 flex justify-end'>
              </div>
            </div>
            <div className="flex gap-x-4 flex-grow">
              <div className='w-1/2 flex justify-end'>
                <p className="text-sm font-semibold text-gray-800">Diskon Lapang</p>
              </div>
              <div className='w-1/2 flex justify-end'>
                <p className="text-sm font-semibold text-gray-800">- Rp</p>
                {/* <div className="flex-grow" /> */}
                <p className="text-sm font-semibold text-gray-800">{numberFormat(discount, false)}</p>
              </div>
            </div>
            <hr />

            <div className="flex gap-x-4 flex-grow">
              <div className='w-1/2 flex justify-end'>
                <p className="text-sm font-bold text-gray-800">BIAYA LAYANAN</p>
              </div>
              <div className='w-1/2 flex justify-end'>
                <p className="text-sm font-bold text-gray-800">Rp{numberFormat(service_fee, false)}</p>
              </div>
            </div>
            <div className="flex gap-x-4 flex-grow">
              <div className='w-1/2 flex justify-end'>
                <p className="text-sm font-bold text-gray-800">BIAYA ADMIN</p>
              </div>
              <div className='w-1/2 flex justify-end'>
                <p className="text-sm font-bold text-gray-800">Belum Termasuk</p>
              </div>
            </div>
            <div className="flex gap-x-4 flex-grow">
              <div className='w-1/2 flex justify-end'>
                <p className="text-sm font-bold text-gray-800">TOTAL BAYAR</p>
              </div>
              <div className='w-1/2 flex justify-end'>
                <p className="text-sm font-bold text-gray-800">Rp</p>
                {/* <div className="flex-grow" /> */}
                <p className="text-sm font-bold text-gray-800">{numberFormat(total, false)}</p>
              </div>
            </div>

          </div>
        </div>
      </div>

      <div className='md:w-1/2'>

        <p className='text-md font-semibold mb-4'>Input Data Pemesan</p>
        <div className='px-6 py-6 flex flex-col gap-y-6 border border-gray-300 rounded-xl mb-8 md:mb-0'>
          <input type='text' ref={name}
            placeholder="Input Nama Pemesan"
            className='py-3 px-4 text-sm font-medium w-full bg-[#F5F5F5] placeholder:text-gray-600 border border-[#F5F5F5] focus:border-[#1C62CC] focus-visible:outline-none mr-2 rounded-lg px-4' />
          <input type='text' ref={phone}
            placeholder="Nomor Telepon"
            className='py-3 px-4 text-sm font-medium w-full bg-[#F5F5F5] placeholder:text-gray-600 border border-[#F5F5F5] focus:border-[#1C62CC] focus-visible:outline-none mr-2 rounded-lg px-4' />
          <input type='text' ref={email}
            placeholder="Alamat Email"
            className='py-3 px-4 text-sm font-medium w-full bg-[#F5F5F5] placeholder:text-gray-600 border border-[#F5F5F5] focus:border-[#1C62CC] focus-visible:outline-none mr-2 rounded-lg px-4' />
        </div>

        <div className='flex w-full justify-end my-6'>
          <button onClick={onNext} className='w-full md:w-fit bg-primaryRed text-white rounded-lg px-10 py-4 text-sm font-semibold '>
            Lanjut Pembayaran
          </button>
        </div>

      </div>

    </div>
  );
}

export default CheckoutConfirm;